import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent implements OnInit {
  @Input()
  label: string;

  @Input()
  hide = false;

  public get isActive() {
    return this._isActive;
  }
  public set isActive(value) {
    this._isActive = value;
    this.changeDetector.markForCheck();
  }
  private _isActive = false;

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnInit() {}
}
